export default {
  title: 'Import workplaces from {dataSource}',
  importWorkplaces: 'Import workplaces',
  next: 'Next',
  previous: 'Previous',
  import: 'Import workplaces',
  retry: 'Retry',
  userMapping: {
    header: 'User mapping',
    description: 'Qmulus reads the workplaces with your PT9800 user and synchronizes the imported workplaces with the PT9800 user of the system user.',
    currentUser: 'Your PT9800 user',
    systemUser: 'PT9800 user of the system user',
    loadWorkplacesFailed: 'Workplaces could not be loaded',
    workplacesUnauthorized: 'PT9800 did not accept your PT9800 user. Select a PT9800 user that has access to this database.',
    loadFailed: 'User mapping could not be loaded',
    saveFailed: 'User mapping could not be saved',
    currentUserMissing: {
      summary: 'Your user is not mapped to a PT9800 user',
      details: 'Ask a user manager to map your user to a PT9800 user in User management, then open the import again.',
    },
    systemUserReason: {
      summary: 'Why the system user needs a PT9800 user',
      details: 'Qmulus synchronizes the jobs, signals, alarms and recipes of the imported workplaces in the background as the system user. Without a PT9800 user for the system user, the imported workplaces stay empty.',
    },
    systemUserUnknown: {
      summary: 'Check the user mapping of the system user',
      details: 'Imported workplaces only synchronize when the system user is mapped to a PT9800 user. Ask a user manager to check it in User management.',
    },
  },
  location: {
    header: 'Location',
    description: 'Select the location to import the workplaces into.',
    linkedToOtherDataSource: {
      summary: 'Location belongs to another PT9800 installation',
      details: 'This location is already linked to {dataSources}. Check that you selected the right location.',
    },
    notLinked: {
      summary: 'Location will be linked',
      details: 'The import links this location to {dataSource}.',
    },
  },
  workplaces: {
    header: 'Workplaces',
    empty: 'This PT9800 installation has no workplaces that can be imported.',
    nameRequired: 'Enter a name.',
    licenseExceeded: '{level}: no licenses left. Your license allows {allowed}.',
    licenseLimitReached: 'License limit reached',
    licenseUsage: '{level}: {used} of {allowed} licenses in use, including the selected workplaces.',
  },
  state: {
    waiting: 'Waiting',
    importing: 'Importing',
    imported: 'Imported',
    failed: 'Failed',
    alreadyImported: 'Already imported',
  },
  progress: {
    current: 'Step {current} of {total}: {step}',
    finished: 'Import finished',
    failed: '{step} failed',
    step: {
      linkLocation: 'Linking location "{name}" to data source',
      createAsset: 'Creating "{name}"',
      loadChambers: 'Loading chambers of "{name}"',
      linkAsset: 'Linking "{name}" to data source',
    },
  },
};
